module.exports = __webpack_public_path__ + "static/media/feed.7e78174b.jpg";